import { THRESHOLD_FILL, THRESHOLD_LABEL } from '@/features/workspace-usage';
import type { LimitState } from '../limitState';

/**
 * The limit chip, as a dot on a phone's menu button (spec 260).
 *
 * A phone's top bar has room for the menu, the page's name, search and the
 * bell, and the chip cost the name all but its first letter. The chip moves
 * into the navigation sheet, words and all; this dot is what stays on the bar
 * to say there is something in there to read. Silent exactly when the chip
 * is.
 *
 * Colour does not travel alone: the dot is a hint, and the chip one tap away
 * carries the word.
 */
export function WorkspaceLimitDot({ state }: { state: LimitState }) {
  if (!state.known || state.source !== 'figures') return null;
  if (state.state === 'under') return null;
  return (
    <span
      aria-hidden="true"
      title={THRESHOLD_LABEL[state.state]}
      className={`ring-background absolute top-1 right-1 size-2.5 rounded-full ring-2 ${THRESHOLD_FILL[state.state]}`}
    />
  );
}
